import {combineReducers} from "redux";
import { notifyMeReducer } from "./notifymeReducer";

const appReducer = combineReducers({
    notifyMeReducer,
});

export default appReducer;